module.exports = __webpack_public_path__ + "img/lander-action-02-wide.1e48617d.webp";